import { jsxs as v, jsx as l } from "react/jsx-runtime";
import { E as d, S as f } from "./icons.types-0722eef5.js";
function m({ title: i, titleId: t, size: a, width: c, height: n, extended: r = !1, ...o }) {
  const h = r ? d : f, s = a ? h[a] : c || h[r ? "s" : "l"], e = a ? h[a] : n || h[r ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: e,
      "aria-labelledby": t,
      ...o,
      children: [
        i ? /* @__PURE__ */ l("title", { id: t, children: i }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Bar_chart_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M48.082 1.5a2.587 2.587 0 0 1 2.577 2.398l.007.194v63.92h2.292v-27.21a2.589 2.589 0 0 1 2.392-2.584l.193-.008h7.529a2.587 2.587 0 0 1 2.577 2.399l.007.193-.001 27.21h1.355c.685 0 1.24.557 1.24 1.244 0 .638-.479 1.164-1.096 1.236l-.144.008H4.99c-.685 0-1.24-.557-1.24-1.244 0-.638.479-1.164 1.096-1.236l.144-.008h1.845l.001-37.535a2.589 2.589 0 0 1 2.391-2.584l.193-.007h7.53a2.587 2.587 0 0 1 2.576 2.398l.008.193-.001 37.534h2.292l.001-47.858a2.589 2.589 0 0 1 2.391-2.585l.193-.007h7.53a2.588 2.588 0 0 1 2.576 2.398l.007.194V68.01h3.445V4.091a2.589 2.589 0 0 1 2.392-2.584l.193-.007h7.53ZM16.95 30.107H9.42a.37.37 0 0 0-.36.285l-.009.085v37.534h8.266l.002-37.534a.37.37 0 0 0-.285-.36l-.085-.01Zm14.99-10.325H24.41a.37.37 0 0 0-.36.286l-.009.085V68.01h8.266l.001-47.858a.37.37 0 0 0-.284-.36l-.085-.01Zm16.143-16.06h-7.529a.37.37 0 0 0-.36.285l-.01.085v63.92h8.267l.001-63.92a.37.37 0 0 0-.284-.36l-.085-.01Zm14.99 36.71h-7.53a.37.37 0 0 0-.359.285l-.01.085v27.21h8.268v-27.21a.37.37 0 0 0-.285-.36l-.084-.01Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Bar_chart_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  m as BarChart
};
